module.exports = __webpack_public_path__ + "static/media/logo_nc.673bd4ad.svg";